// 출시 전 모드 확인 쿼리(?modes=1 · ?field=1 · ?mmo=1)를 받아들일지 정한다(CONTENT-90D-PRD 0.1·3B, REBIRTH-MODES-SPEC 1장).
// 운영 호스트(account/protocol ALLOWED_ORIGINS)에서는 쿼리를 무시한다 — ARPG·MMO 공개는 REBIRTH[].released 스위치 하나로만 바뀐다.
// 개발 서버·로컬 미리보기·workers.dev 진단 호스트에서는 쿼리로 미공개 모드를 연다(QA 경로).
import { ALLOWED_ORIGINS } from '../account/protocol';

/** 이 호스트가 운영 호스트인가(https 정식 주소 기준 + tllhouse.com 및 모든 하위 도메인, 끝 '.' 무시) */
export function isProductionHost(host: string): boolean {
  let h = host.toLowerCase();
  while (h.endsWith('.')) h = h.slice(0, -1); // 정규화된 끝 점('dghero.tllhouse.com.')도 같은 호스트
  if (h === 'tllhouse.com' || h.endsWith('.tllhouse.com')) return true; // 우리 도메인 전체는 운영으로 본다(미공개 서브도메인 포함)
  for (const o of ALLOWED_ORIGINS) if (o === 'https://' + h) return true;
  return false;
}

/** 출시 전 모드 쿼리를 받아들이는가: 개발 서버이거나 운영 호스트가 아니면 true */
export function previewQueryAllowed(host: string, dev: boolean): boolean {
  return dev || !isProductionHost(host);
}

/** 브라우저 현재 주소 기준(브라우저 밖·읽기 실패면 false — 안전한 쪽) */
export function previewQueryAllowedHere(): boolean {
  try {
    const dev = Boolean((import.meta as { env?: { DEV?: boolean } }).env?.DEV);
    if (typeof location === 'undefined') return dev;
    return previewQueryAllowed(location.hostname, dev);
  } catch { return false; }
}
